var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "main-container",
      class: _vm.colorMode === "dark" ? "dark-block" : "",
    },
    [
      _c("h2", [_vm._v("Expanding your footprint in Africa?")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Making business decisions is hard to do in opaque and dynamic\n    markets.Connecting with companies even harder. Our suite of data-driven\n    and digital solutions can help you identify, verify and engage with\n    African companies.\n  "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-wrap" }, [
        _c(
          "a",
          {
            staticClass: "cta-button",
            class: _vm.colorMode === "light" ? "medium-button" : "",
            on: { click: _vm.openLink },
          },
          [_vm._v("See Solutions")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }